import React, { useState, useEffect } from "react";
import {
  Box,
  Typography,
  Paper,
  Divider,
  Grid,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import Layout from "../layout/layout";
import {api}from "../services/api";
import VmMachine from '../assets/vm-symbol.png';
import { useNavigate } from 'react-router-dom';

const AddTemplate = () => {
  const theme = useTheme();
  const [popularServices, setPopularServices] = useState([]);
  const [error, setError] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    const fetchPopularServices = async () => {
      try {
        const response = await api.get("/api/Application/popularServices");
        setPopularServices(response.data);
       
      } catch (error) {
        console.error("Error fetching popular services:", error);
        setError("Failed to fetch popular services");
      }
    };

    fetchPopularServices();
  }, []);

  const handleGridClick = () => {
    navigate('/application_template/application_form');
  };

  return (
    <Layout pageType="sideBar">
      <Box
        sx={{
          flex: 1,
          pl: 2,
          bgcolor: theme.palette.background.default,
          color: theme.palette.text.primary,
        }}
      >
        <Divider />

        {error && <Typography color="error">{error}</Typography>}
        
        <Grid container spacing={2} sx={{ mt: 2 }}>
          <Grid item key='124' xs={12} sm={3} md={4}>
            <Paper
              elevation={3}
              sx={{
                p: 2,
                textAlign: 'center',
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: "center",
                cursor: "pointer",
                borderRadius:'8px',
                border: `2px solid ${theme.palette.borderColor.cardborder}`,
              }}
              onClick={() => handleGridClick()}
            >
              <img
                src={VmMachine}
                alt='Virtual Machine'
                style={{ width: "50px", height: "50px", marginRight: "10px" }}
                onError={(e) => e.target.style.display = 'none'}
              />
              <Typography variant="h6">Virtual Machine</Typography>
            </Paper>
          </Grid>
        </Grid>
      </Box>
    </Layout>
  );
};

export default AddTemplate;
